import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-45421012"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tasks-order-list__wrapper" }
const _hoisted_2 = { class: "tasks-order-list__header" }
const _hoisted_3 = { class: "tasks-order-list__settings-header" }
const _hoisted_4 = { class: "tasks-order-list__main" }
const _hoisted_5 = { class: "tasks-order-list__tasks" }
const _hoisted_6 = {
  key: 0,
  class: "tasks-order-list__tasks-no-access-list"
}
const _hoisted_7 = {
  key: 1,
  class: "tasks-order-list__empty-placeholder"
}

import { computed, inject, onMounted, PropType, Ref, ref } from 'vue';
import {
  TirPmButton,
  TirPmButtonSizeEnum,
  TirPmButtonVariantEnum,
  TirPmScrollbar,
  TirPmDraggableSorting,
  DragModel,
} from 'tir-components';
import { StarIcon } from 'tir-style-system/icons/solid';
import { LabelContent } from '@/components';
import { OrderTaskModel, TaskColumnModel } from '../../models';
import { TaskHeader } from '../../components';
import TaskKanbanCardViewSettingsDropdown from '@/components/tasks-kanban/components/TaskKanbanCardViewSettingsDropdown.vue';
import { TaskViewElementEnum } from '@/components/tasks-kanban/enums';
import TaskOrderLi from './task-order-li.vue';

// #region defineProps
const STEP_SHOW_TASKS = 10;
// #endregion Переменные

// #region refs
/**Кол-во видимых задач */

export default /*#__PURE__*/_defineComponent({
  __name: 'tasks-order-list',
  props: {
  /**id юзера */
  userId: { type: Number },
  /**id юзера из роутера */
  routerUserId: { type: Number },
  /**Список задач */
  tasks: {
    type: Array as PropType<Array<OrderTaskModel>>,
    required: true,
  },
  /**Открывать при монтировании компонента */
  autoOpen: {
    type: Boolean,
    default: false,
  },
  /**Загрузка */
  isLoading: {
    type: Boolean,
    default: false,
  },
  /**Доступ на редактирование всего списка очередности */
  fullChangeAccessOrder: {
    type: Boolean,
    default: false,
  },
},
  emits: ["change", "openTaskDrawer", "deleteTaskOrder", "changeTasks"],
  setup(__props, { emit }) {

const props = __props;


// #endregion defineProps

// #region defineEmits

// #endregion defineEmits

// #region Переменные
/**Колонки */
const columns: TaskColumnModel[] = [
  new TaskColumnModel({
    Type: TaskViewElementEnum.Project,
    Name: '',
    Width: '1.5rem',
    MinWidth: '1.5rem',
  }),
  new TaskColumnModel({
    Type: TaskViewElementEnum.Namespace,
    Name: '',
    Width: '1.5rem',
    MinWidth: '1.5rem',
  }),
  new TaskColumnModel({
    Type: TaskViewElementEnum.Queue,
    Name: 'Очередь',
    Width: '9.375rem',
    MinWidth: '9.375rem',
  }),
  new TaskColumnModel({
    Type: TaskViewElementEnum.Number,
    Name: '№',
    Width: '5rem',
    MinWidth: '5rem',
  }),
  new TaskColumnModel({
    Type: TaskViewElementEnum.Name,
    Name: 'Название',
    Width: '50vw',
    MinWidth: '20rem',
  }),
  new TaskColumnModel({
    Type: TaskViewElementEnum.Status,
    Name: 'Статус',
    Width: '5.1875rem',
    MinWidth: '5.1875rem',
    Align: 'center',
  }),
  new TaskColumnModel({
    Type: TaskViewElementEnum.Priority,
    Name: 'Приоритет',
    Width: '4rem',
    MinWidth: '4rem',
    Align: 'center',
  }),
  new TaskColumnModel({
    Type: TaskViewElementEnum.Difficulty,
    Name: 'Сложность',
    Width: '2rem',
    MinWidth: '2rem',
    Align: 'center',
  }),
  new TaskColumnModel({
    Type: TaskViewElementEnum.EstimateTime,
    Name: 't (оценка)',
    Width: '5rem',
    MinWidth: '5rem',
    Align: 'center',
  }),
  new TaskColumnModel({
    Type: TaskViewElementEnum.WorkTime,
    Name: 't (затрачено)',
    Width: '5rem',
    MinWidth: '5rem',
    Align: 'center',
  }),
];
/**Шаг добавления задач по кнопке "Показать еще" */
const countVisibleTasks = ref(STEP_SHOW_TASKS);
/**Список открыт */
const isOpened = ref(props.autoOpen);
/**Элемент обертки */
const $wrapperElement = inject<Ref<HTMLElement | undefined>>('wrapperElement', ref(undefined));
const viewSettings = ref([
  TaskViewElementEnum.Project,
  TaskViewElementEnum.Namespace,
  TaskViewElementEnum.Queue,
  TaskViewElementEnum.Name,
  TaskViewElementEnum.Number,
  TaskViewElementEnum.Status,
  TaskViewElementEnum.Priority,
  TaskViewElementEnum.Difficulty,
  TaskViewElementEnum.EstimateTime,
  TaskViewElementEnum.WorkTime,
]);
/**Перемещаемый элемент */
const draggbleElement = ref<DragModel<OrderTaskModel>>();
// #endregion refs

// #region computed
/**Текст заголовка */
const headerText = computed(() => {
  return `Очередность для выполнения (${props.tasks.length})`;
});
/**Задачи которые запрещено перемещать */
const tasksChangeNoAccess = computed(() => props.tasks.filter((task) => !task.ChangeAccess));
/**Задачи которые разрешено перемещать */
const tasksChangeAccess = computed(() => props.tasks.filter((task) => task.ChangeAccess));
/**Видимые задачи с запретом на перемещение */
const visibleTasksChangeNoAccess = computed(() =>
  tasksChangeNoAccess.value.slice(0, countVisibleTasks.value),
);
/**Видимые задачи с разрешением на перемещение */
const visibleTasksChangeAccess = computed(() =>
  tasksChangeAccess.value.slice(
    0,
    Math.max(0, countVisibleTasks.value - visibleTasksChangeNoAccess.value.length),
  ),
);

/**Показывать кнопку "Показать еще" */
const isVisibleShowButton = computed(() => props.tasks.length > countVisibleTasks.value);

/**Задачи для перетаскивания */
const dragTasks = computed(() => {
  return (
    visibleTasksChangeAccess.value?.map(
      (task) =>
        new DragModel({
          Data: task,
          AllowDrag: tasksChangeAccess.value.length > 1,
          AllowDrop: false,
        }),
    ) || []
  );
});
// #endregion computed

// #region хуки жизненного цикла
onMounted(() => {
  if (props.routerUserId === props.userId) {
    updateIsOpened(false);
  }
});
// #region Функции

const onDrag = (isDrag: boolean, dragItem: DragModel<OrderTaskModel>) => {
  if (isDrag) {
    draggbleElement.value = dragItem;
  }
};
/**
 * Удалить задачу из списка очередности
 * @param taskId ID Задачи
 */
const removeTask = (taskId: number) => {
  // emit("change", {
  //   Tasks: props.tasks.filter((task) => task.Id !== taskId),
  // });
  emit('deleteTaskOrder', taskId);
};
/**При обновлении флага isOpened */
const updateIsOpened = (value: boolean) => {
  isOpened.value = value;
  if (!isOpened) {
    countVisibleTasks.value = STEP_SHOW_TASKS;
  }
};

/**Показать еще задачи */
const showMore = () => {
  countVisibleTasks.value += STEP_SHOW_TASKS;
};

const onChangeOrder = (data: Array<DragModel<OrderTaskModel>>) => {
  const newTasks = [
    ...visibleTasksChangeNoAccess.value,
    ...data.map((item) => item.Data),
    ...props.tasks.slice(countVisibleTasks.value),
  ];
  emit('change', { Tasks: newTasks, MovedTaskId: draggbleElement.value?.Data?.Id });
  emit('changeTasks', draggbleElement.value?.Data?.Id);
};
// #endregion Функции

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(LabelContent), {
      class: "tasks-order-list",
      delay: 0,
      "flag-mode": "",
      visible: isOpened.value,
      "onUpdate:visible": updateIsOpened
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(StarIcon), { class: "tasks-order-list__header-icon" }),
          _createTextVNode(" " + _toDisplayString(headerText.value), 1)
        ])
      ]),
      default: _withCtx(() => [
        (__props.tasks?.length)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(TaskKanbanCardViewSettingsDropdown, {
                  "tasks-order-pages": "",
                  modelValue: viewSettings.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((viewSettings).value = $event))
                }, null, 8, ["modelValue"])
              ]),
              _createVNode(_unref(TirPmScrollbar), null, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_unref(TaskHeader), {
                        class: "tasks-order-list__columns-header",
                        columns: columns,
                        "enable-sorting": false,
                        "view-settings": viewSettings.value
                      }, null, 8, ["view-settings"]),
                      _createElementVNode("div", _hoisted_5, [
                        (visibleTasksChangeNoAccess.value?.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleTasksChangeNoAccess.value, (task) => {
                                return (_openBlock(), _createBlock(TaskOrderLi, {
                                  task: task,
                                  columns: columns,
                                  "view-settings": viewSettings.value,
                                  "is-loading-delete": __props.isLoading,
                                  key: task.Id,
                                  onOpenTaskDrawer: _cache[1] || (_cache[1] = ($event: any) => (emit('openTaskDrawer', $event)))
                                }, null, 8, ["task", "view-settings", "is-loading-delete"]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true),
                        _createVNode(_unref(TirPmDraggableSorting), {
                          "data-class": "tasks-order-list__drag-task",
                          data: dragTasks.value,
                          "is-allow-scroll": true,
                          "scroll-area": _unref($wrapperElement),
                          "disable-side-indent": true,
                          "is-allow-click-delay": true,
                          indent: 8,
                          onChange: onChangeOrder,
                          onDragComponentOnDrag: onDrag
                        }, {
                          item: _withCtx((props) => [
                            _createElementVNode("div", null, [
                              _createVNode(TaskOrderLi, {
                                task: props.item,
                                columns: columns,
                                "view-settings": viewSettings.value,
                                "is-loading-delete": __props.isLoading,
                                "full-change-access-order": __props.fullChangeAccessOrder,
                                onRemove: removeTask,
                                onOpenTaskDrawer: _cache[2] || (_cache[2] = ($event: any) => (emit('openTaskDrawer', $event)))
                              }, null, 8, ["task", "view-settings", "is-loading-delete", "full-change-access-order"])
                            ])
                          ]),
                          _: 1
                        }, 8, ["data", "scroll-area"])
                      ])
                    ])
                  ])
                ]),
                _: 1
              }),
              (isVisibleShowButton.value)
                ? (_openBlock(), _createBlock(_unref(TirPmButton), {
                    key: 0,
                    variant: _unref(TirPmButtonVariantEnum).SecondaryState,
                    size: _unref(TirPmButtonSizeEnum).Small,
                    style: {"width":"100%"},
                    onClick: showMore
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Показать ещё ")
                    ]),
                    _: 1
                  }, 8, ["variant", "size"]))
                : _createCommentVNode("", true)
            ], 64))
          : (__props.tasks)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, "Задачи отсутствуют"))
            : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})